<template>
  <div class="wrapper">
    <div v-for="(v,i) in classifyList" :key="i">
      <div class="item" v-if="v.children && v.children.length > 0">
        <div class="banner" v-if="v.banner && v.banner.length > 0">
          <el-carousel height="78px" direction="vertical" indicator-position="none">
            <el-carousel-item v-for="(m,n) in v.banner" :key="n">
              <el-image :src="m"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="classify-nav">
          <div class="cn-left">
            <span class="cnl-left">{{ i + 1 }}F</span>
            /
            <span class="cnl-right">{{ v.name }}</span>
          </div>
          <div class="cn-right">
            <div class="nav-list" :class="v.show?'show':''">
              <div class="nav-item" :class="m.active?'active':''" v-for="(m,n) in v.children" :key="n"
                   @click="activeClassify(i,m)">
                <div class="name">{{ m.name }}</div>
                <div class="line"></div>
              </div>
            </div>
            <i class="icon" v-if="v.children && v.children.length > 8"
               :class="v.show?'el-icon-arrow-down':'el-icon-arrow-right'"
               @click="showAllClassify(v)"></i>
          </div>
        </div>
        <div class="main">
          <div class="m-left">
            <el-image :src="v.image"></el-image>
            <div class="info">
              <div class="i-top">
                <div class="name">
                  <span>{{ v.subName || v.name }}</span>
                  <div class="line"></div>
                </div>
                <div class="desc" v-if="v.desc">{{ v.desc }}</div>
              </div>
              <div class="btn" @click="$router.push(`/product/classify?classifyId=${v.classifyId}&name=${v.name}`)">
                查看更多
              </div>
            </div>
          </div>
          <div class="m-right">
            <el-empty v-if="productList[i] && productList[i].length < 1" description="暂无产品"></el-empty>
            <div class="product-list" v-else>
              <div class="pl-item" v-for="(o,p) in productList[i]" :key="p"
                   @click="$router.push(`/product/detail?productId=${o.productId}&name=${v.name}&classifyId=${v.classifyId}&source=list`)">
                <el-image :src="o.image" lazy></el-image>
                <div class="name">{{ o.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {toTreeData} from "@/utils/common";

export default {
  name: "ClassifyProduct",
  data() {
    return {
      classifyList: [],
      productList: []
    }
  },
  created() {
    this.getClassifyList()
  },
  methods: {
    /**
     * 展示全部分类
     * @param parent
     */
    showAllClassify(parent) {
      parent.show = !parent.show;
    },
    /**
     * 分类选定
     * @param parentIndex
     * @param child
     */
    activeClassify(parentIndex, child) {
      this.classifyList[parentIndex].children.map(d => d.active = false)
      child.active = true
      this.getProductList(child.classifyId, parentIndex)
    },
    /**
     * 获取产品列表
     * @param classifyId
     * @param parentIndex
     */
    getProductList(classifyId, parentIndex) {
      this.$request.get('/Product/list', {
        params: {
          classifyId
        }
      }).then(res => {
        if (res.code === 0) {
          this.$set(this.productList, parentIndex, res.data)
        }
      })
    },
    /**
     * 获取分类列表
     */
    getClassifyList() {
      this.$request.get('/Product/classifyList')
          .then(res => {
            if (res.code === 0) {
              this.classifyList = toTreeData({
                data: res.data.map(d => {
                  d['active'] = false
                  d['show'] = false
                  return d
                }),
                idField: 'classifyId',
                parentIdField: 'parentId'
              })
              // 默认每个children第一选定
              this.classifyList = this.classifyList.map((d, index) => {
                if (d.children && d.children.length > 0) {
                  d.children[0].active = true
                  this.getProductList(d.children[0].classifyId, index)
                }
                return d
              })
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;

  .item {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;

    .banner {
      width: 100%;
      height: 78px;
      border-radius: 8px;
      overflow: hidden;
    }

    .classify-nav {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      min-height: 48px;
      margin: 15px 0;

      .cn-left {
        width: 164px;
        height: 100%;
        background-color: #1464FF;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        color: #FFFFFF;
        font-weight: bold;
        line-height: 48px;
        padding: 0 16px;
        text-align: center;
        white-space: nowrap;


        .cnl-left {
          font-size: 26px;
          margin-right: 2px;
        }

        .cnl-right {
          font-size: 18px;
          margin-left: 2px;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .cn-right {
        width: 972px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .nav-list {
          flex: 1;
          width: 0;
          display: grid;
          grid-template-columns:repeat(8, 1fr);
          gap: 7px;
          height: 48px;
          overflow: hidden;

          &.show {
            height: auto;
          }

          .nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            width: 110px;
            height: 48px;
            justify-content: center;

            &.active {
              .name {
                color: #2D2D2D;
              }

              .line {
                opacity: 1;
              }
            }

            .name {
              text-align: center;
              width: 100%;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              color: #6C6C6C;
              font-size: 14px;
              font-weight: bold;
            }

            .line {
              background-color: #1464FF;
              width: 50px;
              height: 4px;
              border-radius: 8px;
              opacity: 0;
            }
          }
        }

        .icon {
          cursor: pointer;
          line-height: 48px;
          margin-top: -2px;
        }
      }
    }

    .main {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 460px;

      .m-left {
        position: relative;
        width: 208px;
        height: 100%;

        .el-image {
          position: absolute;
        }

        .info {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: 50px 20px;

          .i-top {
            display: flex;
            flex-direction: column;
            width: 100%;

            .name {
              color: #FFFFFF;
              font-size: 24px;
              font-weight: bold;
              display: flex;
              flex-direction: column;
              align-items: center;

              .line {
                width: 50px;
                height: 4px;
                background-color: #FFFFFF;
                margin-top: 10px;
              }
            }

            .desc {
              color: #FFFFFF;
              font-size: 22px;
              font-weight: bold;
              margin-top: 50px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 10;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: break-spaces;
              text-align: center;
              word-break: break-all;
            }
          }

          .btn {
            width: 80px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            color: #FFFFFF;
            font-size: 14px;
            text-align: center;
            line-height: 28px;
            cursor: pointer;

            &:hover {
              transform: scale(1.03);
            }
          }
        }
      }

      .m-right {
        width: 972px;
        height: 100%;

        .el-empty {
          margin-top: 30px;
        }

        .product-list {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;

          .pl-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 228px;
            height: 220px;
            background-color: #FFFFFF;
            border-radius: 8px;
            overflow: hidden;
            cursor: pointer;
            transition: all .3s;

            &:hover {
              box-shadow: 0 1px 7px rgba(136, 147, 169, 0.24);
              transform: scale(1.03);
            }

            .el-image {
              width: 100%;
              height: 176px;
            }

            .name {
              text-align: center;
              width: 100%;
              padding: 0 10px;
              height: 44px;
              line-height: 44px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              color: #6C6C6C;
              font-weight: bold;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>